import React, {Component} from 'react';
import styled from "styled-components"
import {PRIMARY_GRAY} from "../constants/COLORS";
import NavigateToCoordsButton from "./NavigateToCoordsButton";
import {CallPhoneButton, ComposeEmailButton} from "./PersonalDataCardButtons";
import {CallerCardBase} from "./CalllerCardBase";

const Card = styled(CallerCardBase)`
    height: 300px;
    @media only screen and (max-width: 675px){
      min-height: 300px;
      height: 100%;
    }
  
  .cardHeader{
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 1rem;
  }
  tbody{
    max-width: 100%;
    width: 100%;
  }
  table{
      width: 100%;

      td{
         font-size: 1.5rem;
         
      }
      td:first-child{
        width: 30%;
        text-align: right;
        padding-right: 2rem;
      }
      td:nth-child(2){
        width: 70%;
        max-width: 70%;
        padding-left: 2rem;
      }
      .emailAddress{
      font-size: 1.2rem;
      text-transform: none;
      }
      tr:last-child td{
      padding: 1.2rem 1rem 0;
        
      }
  }
   
`

class CallerPersonalDataCard extends Component {
    render() {
        const {data} = this.props
        return (
            <Card>
                <div className={'cardHeader'}>Hivo adatai:</div>
                <table>
                    <tbody>
                    <tr>
                        <td>Nev:</td>
                        <td>{data.firstN} {data.lastN}</td>
                    </tr>
                    <tr>
                        <td>Telefonszam:</td>
                        <td>{data.phone}</td>
                    </tr>
                    <tr>
                        <td>Email cim:</td>
                        <td className={'emailAddress'}>{data.email}</td>
                    </tr>
                    <tr>
                        <td><ComposeEmailButton/></td>
                        <td><CallPhoneButton/></td>
                    </tr>
                    </tbody>
                </table>
            </Card>
        );
    }
}

export default CallerPersonalDataCard;